import React, { forwardRef } from "react";
import Icon from "../AppIcon";

const cn = (...classes) => classes.filter(Boolean).join(" ");

const Checkbox = forwardRef(
  (
    {
      className,
      checked = false,
      indeterminate = false,
      disabled = false,
      required = false,
      label,
      description,
      error,
      size = "default",
      onChange,
      labelClassName,
      descriptionClassName,
      errorClassName,
      ...props
    },
    ref
  ) => {
    const sizeConfig = {
      sm: "w-4 h-4",
      default: "w-5 h-5",
      lg: "w-6 h-6",
    };

    const iconSize = {
      sm: 12,
      default: 14,
      lg: 16,
    };

    const handleToggle = () => {
      if (disabled) return;
      onChange?.(!checked);
    };

    return (
      <div className={cn("flex items-start gap-3", className)}>
        {/* Checkbox box */}
        <button
          type="button"
          ref={ref}
          onClick={handleToggle}
          disabled={disabled}
          className={cn(
            "flex items-center justify-center rounded border-2 transition-smooth",
            sizeConfig[size],
            checked || indeterminate
              ? "bg-primary border-primary text-primary-foreground"
              : "bg-background border-border",
            error && "border-destructive",
            disabled && "opacity-50 cursor-not-allowed"
          )}
          role="checkbox"
          aria-checked={indeterminate ? "mixed" : checked}
          {...props}
        >
          {checked && !indeterminate && (
            <Icon name="Check" size={iconSize[size]} />
          )}
          {indeterminate && (
            <Icon name="Minus" size={iconSize[size]} />
          )}
        </button>

        {/* Label / description / error */}
        {(label || description || error) && (
          <div className="flex-1">
            {label && (
              <div
                onClick={handleToggle}
                className={cn(
                  "text-sm font-medium cursor-pointer select-none",
                  error
                    ? "text-destructive"
                    : "text-foreground",
                  disabled && "text-muted-foreground",
                  labelClassName
                )}
              >
                {label}
                {required && (
                  <span className="ml-1 text-destructive">*</span>
                )}
              </div>
            )}

            {description && !error && (
              <div
                className={cn(
                  "text-xs text-muted-foreground mt-1",
                  descriptionClassName
                )}
              >
                {description}
              </div>
            )}

            {error && (
              <div
                className={cn(
                  "text-xs text-destructive mt-1",
                  errorClassName
                )}
              >
                {error}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
);

Checkbox.displayName = "Checkbox";

/**
 * ✅ IMPORTANT
 * Export nommé + export par défaut
 * pour supporter TOUS les imports existants
 */
export { Checkbox };
export default Checkbox;
